export interface Review {
  id: number;
  name: string;
  location: string;
  age: string;
  avatar: string;
  rating: number;
  comment: string;
  purchasedItem: string;
  category: string;
  outfitImage: string;
  date: string;
  highlight: string;
  tags: string[];
}

export const reviews: Review[] = [
  {
    id: 1,
    name: "林雅玲",
    location: "台中市西屯區",
    age: "52歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20elegant%20taiwanese%20woman%2052%20years%20old%20warm%20smile%20natural%20light%20cream%20background%20graceful%20mature%20sophisticated&width=200&height=200&seq=rv_av001&orientation=squarish",
    rating: 5,
    comment: "穿上這件洋裝出席公司年終尾牙，整晚被同事詢問在哪裡買的！版型真的非常修身，把腰線勾勒得很漂亮。最重要的是面料質感超好，穿一整天也不悶熱。Outlet 的價格讓我完全沒有壓力，絕對回購！",
    purchasedItem: "都會氣質修身洋裝",
    category: "洋裝",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20slim%20fit%20midi%20dress%20warm%20brown%20cream%20tone%20elegant%20pose%20interior%20boutique%20soft%20warm%20lighting%20graceful%20sophisticated%20quality%20fabric&width=480&height=600&seq=rv_img001&orientation=portrait",
    date: "2024-12-18",
    highlight: "年終尾牙穿出去被詢問了10次",
    tags: ["修身顯瘦", "質感面料", "正式場合"],
  },
  {
    id: 2,
    name: "陳美惠",
    location: "台中市北屯區",
    age: "48歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20elegant%20taiwanese%20woman%2048%20years%20professional%20gentle%20smile%20warm%20beige%20background%20graceful%20poised%20confident&width=200&height=200&seq=rv_av002&orientation=squarish",
    rating: 5,
    comment: "我已經是這裡的忠實顧客三年了，每季都會來採購幾件。服務人員非常專業，會真心建議適合你的款式，不會只是想賣出去。這件西裝外套讓我在工作場合的氣場立刻提升，同事都說我更有精神了。",
    purchasedItem: "優雅職場西裝外套",
    category: "外套",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20blazer%20suit%20jacket%20professional%20confident%20pose%20warm%20cream%20interior%20background%20sophisticated%20urban%20work%20style%20quality%20designer%20fashion&width=480&height=600&seq=rv_img002&orientation=portrait",
    date: "2024-11-28",
    highlight: "三年忠實顧客，每季必回",
    tags: ["職場穿搭", "專業形象", "氣場提升"],
  },
  {
    id: 3,
    name: "王淑芬",
    location: "台中市豐原區",
    age: "55歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20mature%20taiwanese%20woman%2055%20years%20elegant%20relaxed%20smile%20neutral%20warm%20background%20confident%20poised%20graceful&width=200&height=200&seq=rv_av003&orientation=squarish",
    rating: 5,
    comment: "以前都覺得設計師品牌很遙遠，直到朋友帶我來這裡。Outlet 的折扣讓我終於入手了一直心儀的款式，品質比我想像的還要好。套裝穿起來非常顯瘦，女兒說我穿上去比她還好看！尺寸也很齊全，不用擔心找不到合適的。",
    purchasedItem: "典雅修身套裝組",
    category: "套裝",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20matching%20suit%20set%20skirt%20top%20graceful%20pose%20warm%20beige%20cream%20interior%20background%20sophisticated%20slim%20silhouette%20quality%20fabric%20designer%20fashion&width=480&height=600&seq=rv_img003&orientation=portrait",
    date: "2024-11-15",
    highlight: "女兒說媽媽穿比她還好看",
    tags: ["熟齡穿搭", "顯瘦修飾", "套裝首選"],
  },
  {
    id: 4,
    name: "張曉琳",
    location: "台中市南屯區",
    age: "44歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20elegant%20taiwanese%20woman%2044%20years%20old%20professional%20smile%20light%20neutral%20background%20graceful%20modern%20confident%20sophisticated&width=200&height=200&seq=rv_av004&orientation=squarish",
    rating: 5,
    comment: "這件寬褲的版型完全解決了我長年的困擾！不只是遮住了我不喜歡的部位，整體比例看起來非常修長。搭配任何上衣都很好看，白色、格紋、素色都試過了，怎麼配都好看。材質也很舒服，洗了好幾次還是很挺。",
    purchasedItem: "高腰顯瘦寬版褲",
    category: "褲裝",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20woman%20wearing%20wide%20leg%20pants%20high%20waist%20graceful%20pose%20white%20cream%20background%20slim%20silhouette%20sophisticated%20casual%20chic%20quality%20fabric%20modern%20style&width=480&height=600&seq=rv_img004&orientation=portrait",
    date: "2024-10-30",
    highlight: "解決身材困擾的神奇版型",
    tags: ["顯瘦神褲", "百搭單品", "日常穿搭"],
  },
  {
    id: 5,
    name: "黃麗華",
    location: "台中市大里區",
    age: "57歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20mature%20elegant%20taiwanese%20woman%2057%20years%20warm%20friendly%20smile%20cream%20soft%20background%20graceful%20dignified%20mature%20beauty&width=200&height=200&seq=rv_av005&orientation=squarish",
    rating: 5,
    comment: "退休後想把自己打扮得更有精神，在女兒的推薦下來到這裡。店員非常有耐心，陪我試穿了很多件，完全不會催促。最後選了這件大衣，穿上去整個人都不一樣了，出門散步都覺得自己很有型！連鄰居都問我是不是去哪裡保養了。",
    purchasedItem: "輕奢知性羊毛大衣",
    category: "大衣",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20wool%20long%20coat%20graceful%20pose%20warm%20autumn%20outdoor%20setting%20sophisticated%20dignified%20beauty%20cream%20beige%20tones%20quality%20designer%20fashion&width=480&height=600&seq=rv_img005&orientation=portrait",
    date: "2024-10-12",
    highlight: "退休後重拾穿搭自信的起點",
    tags: ["退休穿搭", "保暖顯瘦", "氣質大衣"],
  },
  {
    id: 6,
    name: "吳秀珍",
    location: "台中市太平區",
    age: "50歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20elegant%20taiwanese%20woman%2050%20years%20graceful%20warm%20smile%20soft%20natural%20light%20background%20serene%20confident%20mature%20sophisticated%20beauty&width=200&height=200&seq=rv_av006&orientation=squarish",
    rating: 5,
    comment: "女兒結婚，我必須要找一件能撐場面又不搶風頭的母親禮服。在這裡找到了完美的選擇！旗袍感的改良式洋裝，既傳統又現代，整個婚禮被所有親友稱讚。新郎的媽媽特別跑來問我哪裡買的，現在兩家人都是這裡的粉絲了！",
    purchasedItem: "改良旗袍風優雅洋裝",
    category: "洋裝",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20woman%20wearing%20traditional%20modern%20qipao%20cheongsam%20inspired%20dress%20graceful%20dignified%20pose%20warm%20soft%20background%20sophisticated%20formal%20occasion%20quality%20fabric%20beautiful&width=480&height=600&seq=rv_img006&orientation=portrait",
    date: "2024-09-20",
    highlight: "女兒婚禮最受矚目的母親裝",
    tags: ["婚禮場合", "改良旗袍", "人生大事"],
  },
  {
    id: 7,
    name: "劉靜宜",
    location: "台中市清水區",
    age: "46歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20elegant%20taiwanese%20woman%2046%20years%20professional%20gentle%20confident%20smile%20warm%20neutral%20background%20graceful%20sophisticated%20modern&width=200&height=200&seq=rv_av007&orientation=squarish",
    rating: 5,
    comment: "本來只是陪朋友來，結果自己反而買了更多。針織上衣的質感完全超出預期，比百貨公司同款式的品質還要好，但價格親切太多了。顏色選擇也很豐富，我一次買了三個顏色！洗了多次還是很軟很舒服，沒有縮水也沒有起球。",
    purchasedItem: "柔軟修身針織上衣",
    category: "上衣",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20woman%20wearing%20soft%20knit%20sweater%20top%20graceful%20casual%20chic%20pose%20warm%20cream%20interior%20background%20sophisticated%20comfortable%20style%20quality%20fabric%20multiple%20colors%20modern&width=480&height=600&seq=rv_img007&orientation=portrait",
    date: "2024-09-05",
    highlight: "一次買了三個顏色的針織上衣",
    tags: ["百搭上衣", "柔軟舒適", "多色選擇"],
  },
  {
    id: 8,
    name: "蔡宜君",
    location: "台中市霧峰區",
    age: "53歲",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20mature%20taiwanese%20woman%2053%20years%20warm%20smile%20elegant%20pose%20cream%20warm%20background%20graceful%20poised%20dignified%20mature%20beauty&width=200&height=200&seq=rv_av008&orientation=squarish",
    rating: 5,
    comment: "每次換季都要來報到！這裡的商品流動很快，每次來都有新驚喜。上次看到喜歡的猶豫了，結果下週回來就沒了，後悔很久。現在看到喜歡的就直接帶走。老公說我的衣品越來越好，其實是這裡的東西真的太有品味了！",
    purchasedItem: "春夏花漾印花洋裝",
    category: "洋裝",
    outfitImage: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20wearing%20floral%20print%20dress%20spring%20summer%20graceful%20outdoor%20pose%20warm%20natural%20light%20background%20sophisticated%20cheerful%20quality%20fabric%20beautiful%20pattern&width=480&height=600&seq=rv_img008&orientation=portrait",
    date: "2024-08-18",
    highlight: "換季必報到，猶豫就輸了",
    tags: ["換季採購", "印花洋裝", "春夏必備"],
  },
];

export const reviewStats = {
  totalReviews: 234,
  averageRating: 4.9,
  fiveStarPercent: 96,
  repeatCustomerPercent: 78,
  categories: [
    { name: "全部", count: 234 },
    { name: "洋裝", count: 89 },
    { name: "套裝", count: 54 },
    { name: "外套", count: 38 },
    { name: "褲裝", count: 32 },
    { name: "上衣", count: 21 },
  ],
};
